// extracted by mini-css-extract-plugin
export default {"wrap":"more_wrap__Lk7YQ"};